
import React from 'react'

type Props = {}

const ObrErrorMessage = ({message}:any) => {
 

  return (
    <div>
    <small className="text-danger">{message}</small>
    </div>
  )
}

export default ObrErrorMessage